for (let i = 0; i < document.getElementsByClassName('arrow_wrapper').length; i++) {
    document.getElementsByClassName('arrow_wrapper')[i].addEventListener('click', function () {

        if(document.getElementsByClassName('dropdown')[i].style.display === 'block') {
            document.getElementsByClassName('dropdown')[i].style.display = 'none';
            document.getElementsByClassName('arrow_wrapper')[i].style.transform = 'rotateX(0deg)';
            
        } else {
            document.getElementsByClassName('dropdown')[i].style.display = 'block';
            document.getElementsByClassName('arrow_wrapper')[i].style.transform = 'rotateX(180deg)';
        }
    });
}